import { Icons as e } from "../Icons/Icons.mjs";
import "react";
import { css as t, keyframes as n, styled as r } from "styled-components";
import { useTranslation as i } from "@maat/store-i18n";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/AILoading/AILoading.tsx
var s = n`
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
`, c = n`
    0% { transform: rotate(0deg) scale(0.9); }
    50% { transform: rotate(180deg) scale(1.1); }
    100% { transform: rotate(360deg) scale(0.9); }
`, l = n`
    0% { transform: rotate(360deg) scale(1); }
    50% { transform: rotate(180deg) scale(0.85); }
    100% { transform: rotate(0deg) scale(1); }
`, u = r.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(3)};
`, d = r.div`
    position: relative;
    width: ${({ $size: e }) => e}px;
    height: ${({ $size: e }) => e}px;
    display: flex;
    align-items: center;
    justify-content: center;
`, f = r.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Create a much deeper, richer saturation without screen blend mode */
    background: linear-gradient(
        110deg,
        #ff4c4c,
        #c06c84,
        #6c5b7b,
        #3b82f6,
        #00d2ff,
        #ff8a00,
        #ff4c4c
    );
    background-size: 300% 300%;
    animation: ${s} 6s ease-in-out infinite;

    /* Distinct blobs using different border-radius shapes and animation directions */
    ${({ $index: e }) => e === 1 ? t`
                border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
                animation:
                    ${c} 6s linear infinite,
                    ${s} 6s ease-in-out infinite;
                filter: blur(12px);
                opacity: 0.85;
            ` : e === 2 ? t`
                border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
                animation:
                    ${l} 8s linear infinite,
                    ${s} 8s ease-in-out infinite;
                filter: blur(16px);
                opacity: 0.9;
                transform-origin: 45% 55%;
            ` : e === 3 ? t`
                border-radius: 30% 70% 70% 30% / 30% 30% 70% 70%;
                animation:
                    ${c} 10s linear infinite,
                    ${s} 10s ease-in-out infinite;
                filter: blur(8px);
                opacity: 0.7;
                transform-origin: 55% 45%;
            ` : ""}
`, p = r.div`
    position: relative;
    z-index: 10;
    width: ${({ $size: e }) => e * .3}px;
    height: ${({ $size: e }) => e * .3}px;
    background: rgba(255, 255, 255, 0.55);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 25%; /* Squircle appearance */
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    color: white;
`, m = r.p`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    margin: 0;
    animation: pulseText 2s ease-in-out infinite;

    @keyframes pulseText {
        0%,
        100% {
            opacity: 0.6;
        }
        50% {
            opacity: 1;
        }
    }
`, h = ({ text: t, size: n = 120 }) => {
	let { t: r } = i("ds"), s = t ?? r("ds:aiLoading.default");
	return /* @__PURE__ */ o(u, { children: [/* @__PURE__ */ o(d, {
		$size: n,
		children: [
			/* @__PURE__ */ a(f, { $index: 1 }),
			/* @__PURE__ */ a(f, { $index: 2 }),
			/* @__PURE__ */ a(f, { $index: 3 }),
			/* @__PURE__ */ a(p, {
				$size: n,
				children: /* @__PURE__ */ a(e.Sparkles, {
					size: n * .16,
					strokeWidth: 2,
					ai: !0
				})
			})
		]
	}), s && /* @__PURE__ */ a(m, { children: s })] });
};
//#endregion
export { h as AILoading };
